import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { useAppSelector as useSelector } from 'dux/app/hooks';

import { Button } from 'Components/LegacyButton';

import { cta } from 'assets/content/landingPages/skincare';

import {
  getHasActiveHaircareSubscription,
  getHasCompletedSkincareConsultation,
} from 'dux/user/selectors';

const SkincareConsultationCTA = ({
  className,
  dataClick,
  dataFrom,
  dataTestId,
  isFixed,
  noMargin,
}) => {
  const userHasCompleteSkincareConsultation = useSelector(getHasCompletedSkincareConsultation);
  const hasHaircareSubscription = useSelector(getHasActiveHaircareSubscription);

  const mobileCTAContent =
    cta[
      userHasCompleteSkincareConsultation
        ? 'hasCompletedSkincareConsultation'
        : hasHaircareSubscription
        ? 'hasNotAnsweredSkincareQuestionsAndHasHaircareSubscription'
        : 'hasNotAnsweredSkincareQuestions'
    ];

  return (
    <Button
      className={className}
      Component={Link}
      data-click={dataClick}
      data-from={dataFrom}
      data-testid={dataTestId}
      fixed={isFixed}
      noMargin={noMargin}
      to={mobileCTAContent.url}
      variant="vert"
    >
      {mobileCTAContent.label}
    </Button>
  );
};

SkincareConsultationCTA.propTypes = {
  dataTestId: PropTypes.string,
  dataClick: PropTypes.string,
  dataFrom: PropTypes.string,
  isFixed: PropTypes.bool,
  className: PropTypes.string,
  noMargin: PropTypes.bool,
};

SkincareConsultationCTA.defaultProps = {
  dataClick: null,
  dataFrom: null,
  dataTestId: null,
  isFixed: false,
  className: null,
  noMargin: null,
};

export default SkincareConsultationCTA;
